import React, { useEffect, useState, useRef } from "react";
import Paper from "@material-ui/core/Paper";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import Checkbox from "@material-ui/core/Checkbox";
import { Button, Row, Col, Form, Alert, Pagination } from "react-bootstrap";
import AppBar from "@mui/material/AppBar";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import * as echarts from "echarts";
//import AADService from "../funcionesAuth.js";

function VulnModel() {
    const [tabValue, setTabValue] = useState(0);
    const [historicData, setHistoricData] = useState(null);
    const [latestReport, setLatestReport] = useState(null);
    const [loading, setLoading] = useState(true);
    const [downloadLoading, setDownloadLoading] = useState(false);
    const chartRef = useRef(null);
    const chartInstance = useRef(null);
    //const AzureADService = new AADService();
    //const token = AzureADService.getToken();

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    const downloadLatestReport = async () => {
        if (downloadLoading || !historicData || historicData.length === 0) return;
        setDownloadLoading(true);
        try {
            // Obtener la fecha más reciente del histórico
            const latestRecord = historicData[historicData.length - 1];
            const fechaStr = latestRecord.Fecha; // Formato: "YYYY-MM"
            
            // Convertir "2025-12" a "01_12_25"
            const [year, month] = fechaStr.split('-');
            const yy = year.slice(-2); // Últimos 2 dígitos del año
            const dateParam = `01_${month}_${yy}`; // Usar día 01 como predeterminado

            const response = await fetch(
                `${process.env.REACT_APP_API_URL}administrador/latestreport/?date=${dateParam}`
            );
            
            if (!response.ok) throw new Error("Error obteniendo el último reporte");

            const data = await response.json();
            if (!data.download_url) throw new Error("URL de descarga inválida");

            window.location.href = data.download_url;
        } catch (error) {
            console.error(error);
            alert("Error descargando el último corte disponible: " + error.message);
        } finally {
            setDownloadLoading(false);
        }
    };
                
    // Fetch datos del histórico
    useEffect(() => {
    const Info = async () => {

      const result = await fetch(
        process.env.REACT_APP_API_URL + "administrador/vulnmodel/",
        {
          method: "GET",
          headers: {
            "Content-type": "application/json;",
            //Authorization: "Bearer " + token,
          },
        }
      );
      if (result.status == 200) {
        let datainfo = await result.json();
        setHistoricData(datainfo);
      }
      else {
        Alert("Error cargando los datos");
        }
    };
    Info();

    }, []);

    // Inicializar gráfica echarts
    useEffect(() => {
        if (historicData && historicData.length > 0 && chartRef.current) {
            // Procesar datos
            const months = historicData.map(item => item.Fecha);
            const criticidades = ["Baja y Media", "Alta", "Crítica", "Muy Crítica"];
            
            const series = criticidades.map(criticidad => ({
                name: criticidad,
                type: 'line',
                data: historicData.map(item => item[criticidad] || 0),
                smooth: true
            }));

            // Inicializar gráfica
            if (!chartInstance.current) {
                chartInstance.current = echarts.init(chartRef.current);
            }

            const option = {
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: criticidades,
                    bottom: 0
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '10%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: months
                },
                yAxis: {
                    type: 'value'
                },
                series: series
            };

            chartInstance.current.setOption(option);
            chartInstance.current.resize();

            // Limpiar al desmontar
            return () => {
                if (chartInstance.current) {
                    chartInstance.current.dispose();
                    chartInstance.current = null;
                }
            };
        }
    }, [historicData]);

    // Redimensionar gráfica cuando cambia de pestaña
    useEffect(() => {
        if (chartInstance.current) {
            setTimeout(() => {
                chartInstance.current.resize();
            }, 0);
        }
    }, [tabValue]);

    return (
        <div>
            <AppBar position="static" color="default">
                <Tabs 
                    value={tabValue} 
                    onChange={handleTabChange}
                    indicatorColor="primary"
                    textColor="primary"
                >
                    <Tab label="Histórico" />
                    {/*<Tab label="Cruce de información" />*/}
                </Tabs>
            </AppBar>

            {tabValue === 0 && (
                <div style={{ padding: 20 }}>
                    <h3>Histórico de Vulnerabilidades CVE por Criticidad</h3>
                    <br />
                    {historicData && (
                        <Row>
                            <Col md={6}>
                                <TableContainer component={Paper} style={{ maxHeight: 500 }}>
                                    <Table stickyHeader size="small">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell><strong>Fecha</strong></TableCell>
                                                <TableCell align="right"><strong>Muy Crítica</strong></TableCell>
                                                <TableCell align="right"><strong>Crítica</strong></TableCell>
                                                <TableCell align="right"><strong>Alta</strong></TableCell>
                                                <TableCell align="right"><strong>Baja y Media</strong></TableCell>
                                                <TableCell align="right"><strong>Total</strong></TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {historicData.map((row, index) => (
                                                <TableRow key={index} hover>
                                                    <TableCell>{row.Fecha}</TableCell>
                                                    <TableCell align="right">{row["Muy Crítica"].toLocaleString()}</TableCell>
                                                    <TableCell align="right">{row["Crítica"].toLocaleString()}</TableCell>
                                                    <TableCell align="right">{row["Alta"].toLocaleString()}</TableCell>
                                                    <TableCell align="right">{row["Baja y Media"].toLocaleString()}</TableCell>
                                                    <TableCell align="right">{row["Total"].toLocaleString()}</TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                <div style={{ marginTop: 10, textAlign: 'center' }}>
                                    <Button 
                                        variant="primary"
                                        onClick={downloadLatestReport}
                                        disabled={downloadLoading}
                                        >
                                        {downloadLoading ? "Descargando..." : "Descargar último corte disponible"}
                                    </Button>
                                </div>
                            </Col>
                            <Col md={6}>
                                <div 
                                    ref={chartRef} 
                                    style={{ width: '100%', height: '500px' }}
                                />
                            </Col>
                        </Row>
                    )}
                </div>
            )}
        </div>
    );
}

export default VulnModel;